import type { ReactNode } from 'react'

export type ChildrenProps = { children?: ReactNode }

export type DtoQuantity<T> = {
  value: T
  unit: Unit
}

export enum NoneUnit {
  NONE = '',
}

// Volume units
export enum VolumeUnit {
  LITER = 'L',
  OUNCE_FLUID_US = 'US fl oz',
  PINT_LIQUID_US = 'US pt',
  QUART_LIQUID_US = 'US qt',
  GALLON_LIQUID_US = 'gal',
}

// Mass units
export enum MassUnit {
  KILOGRAM = 'kg',
}

// Percentage unit
export enum PercentageUnit {
  PERCENT = '%',
}

// Distance units
export enum DistanceUnit {
  MILLIMETER = 'mm',
  CENTIMETER = 'cm',
  DECIMETER = 'dm',
  METER = 'm',
  KILOMETER = 'km',
  INCH = 'in',
  FOOT = 'ft',
  YARD = 'yd',
  MILE = 'mi',
}

// Temperature unit
export enum TemperatureUnit {
  CELSIUS = '°C',
}

// Pressure unit
export enum PressureUnit {
  PASCAL = 'Pa',
}

// Decibel unit
export enum DecibelUnit {
  DECIBEL_MILLIWATTS = 'dBm',
}

export enum Unit {
  NONE = NoneUnit.NONE,
  // Volume units
  LITER = VolumeUnit.LITER,
  OUNCE_FLUID_US = VolumeUnit.OUNCE_FLUID_US,
  PINT_LIQUID_US = VolumeUnit.PINT_LIQUID_US,
  QUART_LIQUID_US = VolumeUnit.QUART_LIQUID_US,
  GALLON_LIQUID_US = VolumeUnit.GALLON_LIQUID_US,

  // Mass units
  KILOGRAM = MassUnit.KILOGRAM,

  // Percentage unit
  PERCENT = PercentageUnit.PERCENT,

  // Distance units
  MILLIMETER = DistanceUnit.MILLIMETER,
  CENTIMETER = DistanceUnit.CENTIMETER,
  DECIMETER = DistanceUnit.DECIMETER,
  METER = DistanceUnit.METER,
  KILOMETER = DistanceUnit.KILOMETER,
  INCH = DistanceUnit.INCH,
  FOOT = DistanceUnit.FOOT,
  YARD = DistanceUnit.YARD,
  MILE = DistanceUnit.MILE,

  // Temperature unit
  CELSIUS = TemperatureUnit.CELSIUS,

  // Pressure unit
  PASCAL = PressureUnit.PASCAL,

  // Decibel unit
  DECIBEL_MILLIWATTS = DecibelUnit.DECIBEL_MILLIWATTS,
}

export enum BatteryLevel {
  FULL = 'FULL',
  GOOD = 'GOOD',
  MEDIUM = 'MEDIUM',
  WARNING = 'WARNING',
  CRITICAL = 'CRITICAL',
}

export enum VolumeDisplayType {
  USABLE_VOLUME = 'USABLE_VOLUME',
  TOTAL_VOLUME = 'TOTAL_VOLUME',
}

export type DtoLocalDate = {
  year: number
  month: number
  day: number
}

export enum AppFlavor {
  FOXMOBILE = 'foxmobile',
  PELLETTRACKER = 'pellettracker',
}

export type DtoPaginatedResult<T> = {
  page: number
  pageSize: number
  totalPages: number
  totalRows: number
  data: T[]
}

export type DtoOffsetResult<T> = {
  offset: number
  total: number
  data: T[]
}

export type ComputedStorage = {
  usableQuantity: DtoQuantity<number>
  totalQuantity: DtoQuantity<number>
  productSafetyMargin: number
  productName: string
  isCollectingProduct: boolean
  displayAs100Percent: VolumeDisplayType
}

export type JwtDto = {
  token_type: string
  access_token: string
  refresh_token: string
}
